import React from "react";
import { Box, Typography } from "@mui/material";
import { ReactComponent as CultureHubIcon } from "../../assets/icons/hub-cultura.svg";

const AreaLogo = () => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: "46px" }}>
    <CultureHubIcon aria-hidden="true" />
    <Typography
      variant="h5"
      component="h1"
      id="culturehub-page-title"
      tabIndex={-1}
      sx={{
        fontFamily: "inherit",
        fontWeight: 700,
        fontSize: "20px",
        color: "#1e1f24",
      }}
    >
      HUB de Cultura
    </Typography>
  </Box>
);

export default AreaLogo;
